import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { APPLICANT_UPDATE_MODE } from "./voucher-thank-you-cta";

/**
 * Reads the `mode` query parameter from the current route (react-router-dom v5)
 * and exposes derived flags so callers can avoid sprinkling query-string parsing.
 */
export const useVoucherFormMode = () => {
  const { search } = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(search || "");
    const mode = params.get("mode") || undefined;

    return {
      mode,
      isApplicantUpdateMode: mode === APPLICANT_UPDATE_MODE,
    };
  }, [search]);
};

export default useVoucherFormMode;
